import { EventState, EventSubType, EventType, ExecuteEvent } from "pubsub/PubSub.const";
import IEvent from "./IEvent";
import { getInteractor } from "services/local.service";
import { EventDto, IEventDto } from "pubsub/dto";
import { refactorSavingEvent } from "pubsub/PubSub.helper";
import { branchReqNotification } from "pubsub/services/branch-request.service";

export default class BranchRequestEvent extends IEvent {
  constructor(prefixKey: string) {
    super(prefixKey, EventType.BRANCH_REQUEST);
  }

  override handleEvent = async (limitRetry: number) => {
    const eventList: EventDto[] = (
      await getInteractor(this.prefixKey).LocalEventService.find({
        type: this.eventType,
        state: [EventState.NEW, EventState.RESENT],
      })
    ).map((item: IEventDto) => new EventDto(item));
    const savingEvents: IEventDto[] = [];
    for (let index = 0; index < eventList.length; index++) {
      const eventItem = eventList[index];
      const eventContent = eventItem.contentObj;
      const notificationId = eventContent.notification_id;
      let executeEventValue: ExecuteEvent = ExecuteEvent.FAIL;

      if (notificationId) {
        switch (eventItem.subtype) {
          case EventSubType.CREATE:
          case EventSubType.UPDATE:
            executeEventValue = await branchReqNotification(this.prefixKey, notificationId);
            break;

          default:
            executeEventValue = ExecuteEvent.SUCCESSES;
            break;
        }
      }

      // Update event before saving in local db
      const refactorEvent = refactorSavingEvent(eventItem, executeEventValue, limitRetry);
      if (refactorEvent) savingEvents.push(refactorEvent);
    }

    await getInteractor(this.prefixKey).LocalEventService.save(savingEvents);
    return true;
  };
}
